<template>
    <Modal v-if="shown"
           :title="$t('investor.exchange.bidsReponseDialog.title')"
           :close-on-click-outside="false"
           @close="show(false)"
    >
        <template v-slot:body>
            <div class="bidMessages text_left modal-content">
                <p v-if="bidsResponse.instantBuysCount > 0" class="background_success_color base_padding font_bold">
                    {{$t('investor.exchange.bidsReponseDialog.instantBuys', {count: bidsResponse.instantBuysCount})}}
                </p>
                <p v-if="bidsResponse.highestBidsCount > 0" class="background_success_color base_padding font_bold">
                    {{$t('investor.exchange.bidsReponseDialog.highestBids', {count: bidsResponse.highestBidsCount})}}
                </p>
                <p v-if="bidsResponse.successfulBidsCount > 0" class="background_warning_color base_padding font_bold">
                    {{$t('investor.exchange.bidsReponseDialog.successfulBids', {count: bidsResponse.successfulBidsCount})}}
                </p>
                <div v-if="bidsResponse.failedBidsCount > 0" class="background_error_color base_padding">
                    <p class="font_bold">
                        {{$t('investor.exchange.bidsReponseDialog.failedBids', {count: bidsResponse.failedBidsCount})}}
                    </p>
                    <div v-if="bidsResponse.failedBidsMessages">
                        <span class="font_bold">{{$t('investor.exchange.bidsReponseDialog.failedBidReasons')}}</span>
                        <br/>
                        <span v-for="(count, msg) in bidsResponse.failedBidsMessages"
                              v-html="count + ' x ' + msg">
                        </span>
                    </div>
                </div >
            </div>
            <div class="flex flex_end margin_top">
                <md-button class="md-primary" @click="show(false)">{{ $t('common.button.ok') }}</md-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";

export default {
    components: {Modal},
    data() {
    	return {
			shown: false,
            bidsResponse: {}
        }
    },
    methods: {
    	show(value) {
    		this.shown = value;
        },
        showWithResponse(bidsResponse) {
    		this.bidsResponse = bidsResponse;
    		this.show(true);
        }
    }
}
</script>